import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import type { ReactNode } from "react";

export interface AuthBrandPanelProps {
  appName: ReactNode;
  tagline?: ReactNode;
}

/** Decorative side panel shown alongside the auth form on wide screens. */
export function AuthBrandPanel({ appName, tagline }: AuthBrandPanelProps) {
  return (
    <Box
      sx={{
        display: { xs: "none", md: "flex" },
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "flex-start",
        gap: 2,
        width: "50%",
        px: 8,
        color: "primary.contrastText",
        background: (theme) =>
          `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
      }}
    >
      <Typography variant="h3" sx={{ fontWeight: 800 }}>
        {appName}
      </Typography>
      {tagline ? (
        <Typography variant="body1" sx={{ opacity: 0.9, maxWidth: 420 }}>
          {tagline}
        </Typography>
      ) : null}
    </Box>
  );
}
